import { Injectable } from '@angular/core';

@Injectable()
export class Config {
    api_key: string;
    delivery_token: string;
    environment: string;
  }
